import React from 'react';

import LoginForm from './components/LoginForm';

const Login = () => {
  return (
    <div
      className="min-h-screen flex"
      style={{ background: 'var(--color-background)' }}
    >
      {/* Left Panel - Branding (hidden on mobile) */}
      <div
        className="hidden lg:flex lg:w-5/12 xl:w-1/2 flex-col justify-between p-12 relative overflow-hidden"
        style={{ background: 'var(--color-card)', borderRight: '2px solid var(--color-border)' }}
      >
        {/* Geometric Background Accent */}
        <div
          style={{
            position: 'absolute',
            top: '-80px',
            right: '-80px',
            width: '320px',
            height: '320px',
            border: '2px solid rgba(0, 79, 152, 0.15)',
            borderRadius: '2px',
            transform: 'rotate(15deg)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '120px',
            left: '-40px',
            width: '200px',
            height: '200px',
            border: '2px solid rgba(255, 87, 34, 0.1)',
            borderRadius: '2px',
            transform: 'rotate(-8deg)',
          }}
        />

        {/* Logo */}
        <div className="flex items-center gap-3 relative z-10">
          <div
            style={{
              width: '44px',
              height: '44px',
              background: 'var(--color-primary)',
              borderRadius: 'var(--radius-sm)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <span style={{ fontFamily: 'var(--font-heading)', fontSize: '18px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.04em' }}>
            Veiassistent
          </span>
        </div>

        {/* Main Branding Content */}
        <div className="relative z-10">
          <div
            style={{
              display: 'inline-block',
              background: 'var(--color-accent)',
              padding: '4px 12px',
              marginBottom: '20px',
              borderRadius: 'var(--radius-sm)',
            }}
          >
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FFFFFF' }}>
              Norsk Veiassistent
            </span>
          </div>

          <h1
            style={{
              fontFamily: 'var(--font-heading)',
              fontSize: '36px',
              fontWeight: 700,
              lineHeight: 1.2,
              letterSpacing: '0.02em',
              color: 'var(--color-foreground)',
              marginBottom: '16px',
            }}
          >
            Intelligent
            <br />
            <span style={{ color: 'var(--color-primary)' }}>Veiplanlegging</span>
          </h1>

          <p
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: 1.6,
              color: 'var(--color-muted-foreground)',
              maxWidth: '340px',
            }}
          >
            Administrer bompasseringer, planlegg ruter og optimaliser kjørekostnader på norske veier.
          </p>

          {/* Feature List */}
          <div style={{ marginTop: '32px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {[
              'Sanntids trafikkdata',
              'Automatisk bomberegning',
              'Abonnementshåndtering',
            ]?.map((feature) => (
              <div key={feature} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ width: '6px', height: '6px', background: 'var(--color-accent)', borderRadius: '1px', flexShrink: 0 }} />
                <span style={{ fontFamily: 'var(--font-caption)', fontSize: '14px', fontWeight: 400, color: 'var(--color-muted-foreground)', letterSpacing: '0.01em' }}>
                  {feature}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="relative z-10">
          <p style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', fontWeight: 400, color: 'rgba(156, 163, 175, 0.5)', letterSpacing: '0.02em' }}>
            © 2024 Veiassistent AS · Alle rettigheter forbeholdt
          </p>
        </div>
      </div>
      {/* Right Panel - Login Form */}
      <div className="flex-1 flex flex-col justify-center items-center px-6 sm:px-12 lg:px-16 py-12">
        {/* Mobile Logo */}
        <div className="lg:hidden flex items-center gap-3 mb-10">
          <div
            style={{
              width: '40px',
              height: '40px',
              background: 'var(--color-primary)',
              borderRadius: 'var(--radius-sm)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <span style={{ fontFamily: 'var(--font-heading)', fontSize: '18px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.04em' }}>
            Veiassistent
          </span>
        </div>

        <div style={{ width: '100%', maxWidth: '400px' }}>
          {/* Form Header */}
          <div style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontFamily: 'var(--font-heading)',
                fontSize: '32px',
                fontWeight: 700,
                lineHeight: 1.2,
                letterSpacing: '0.02em',
                color: 'var(--color-foreground)',
                marginBottom: '10px',
              }}
            >
              Logg inn
            </h2>
            <p
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: '16px',
                fontWeight: 500,
                lineHeight: 1.5,
                color: 'var(--color-muted-foreground)',
              }}
            >
              Skriv inn dine opplysninger for å fortsette
            </p>
          </div>

          {/* Divider */}
          <div style={{ height: '2px', background: 'var(--color-border)', marginBottom: '32px' }} />

          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default Login;
